import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  dark?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  dark = false
}: SectionProps) {
  return <section id={id} className={`py-8 md:py-16 overflow-hidden ${dark ? 'bg-dark text-white' : 'bg-white text-dark'} ${className}`} data-id="element-385">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-60px'
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-386">
        {children}
      </motion.div>
    </section>;
}